import {ImageOpSystem} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-system"
import {ImageOpNodeDataObject} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/data-object/node"
import {DownloadFormat} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-data-object"
import {REF_COUNT_DEBUG_ID_INITIAL} from "@cm/utils"

export class OperatorStackImageOpSystem extends ImageOpSystem {
    override dispose() {
        this.setSourceImage(null)
        this.clearAllCachedSourceImages()
        super.dispose()
    }

    clearAllCachedSourceImages() {
        this.texturesApi.logger.debug("Clearing all cached source images")
        this.sourceImageByDataObjectId.forEach((image) => image.release(REF_COUNT_DEBUG_ID_INITIAL))
        this.sourceImageByDataObjectId.clear()
    }

    setSourceImageDataObjectId(args: {dataObjectId: string; channels: number; downloadFormat: DownloadFormat} | null) {
        if (!args) {
            this.setSourceImage(null)
        } else {
            const cachedImage = this.sourceImageByDataObjectId.get(args.dataObjectId)
            if (cachedImage) {
                this.texturesApi.logger.trace("Using cached source image")
                this.setSourceImage(cachedImage)
            } else {
                this.texturesApi.logger.trace("Creating new source image")
                const sourceImage = new ImageOpNodeDataObject({
                    dataObjectId: args.dataObjectId,
                    channels: args.channels,
                    downloadFormat: args.downloadFormat,
                })
                sourceImage.debugId = `sourceImage.${args.dataObjectId}`
                this.sourceImageByDataObjectId.set(args.dataObjectId, sourceImage)
                this.setSourceImage(sourceImage)
            }
        }
    }

    get currentSourceImage() {
        return this._currentSourceImage
    }

    setSourceImage(image: ImageOpNodeDataObject | null) {
        if (this._currentSourceImage === image) {
            return
        }
        this.texturesApi.logger.trace("Setting source image")
        this._currentSourceImage?.release(REF_COUNT_DEBUG_ID_CURRENT_SOURCE_IMAGE)
        this._currentSourceImage = image
        this._currentSourceImage?.addRef(REF_COUNT_DEBUG_ID_CURRENT_SOURCE_IMAGE)
        this.sourceImageChanged.emit(image)
    }

    private sourceImageByDataObjectId = new Map<string, ImageOpNodeDataObject>()
    private _currentSourceImage: ImageOpNodeDataObject | null = null
}

const REF_COUNT_DEBUG_ID_CURRENT_SOURCE_IMAGE = "OperatorStackImageOpSystem.currentSourceImage"
